import { Tag } from 'antd';
import { EditOutlined } from '@ant-design/icons';
import React from 'react';

const tagStyle = {
  fontSize: '9px',
  padding: '1px 3px',
  lineHeight: '10px',
  marginRight: '5px',
};

export const getCfColumns = (onUpdate) => [
  {
    title: 'Field Name',
    render: (record) => (
      <div>
        {record?.field_name}
        &nbsp;
        {record?.is_system_field ? <Tag color="red" style={tagStyle}>System</Tag> : ''}
      </div>
    ),
  },
  {
    title: 'Field Type',
    render: (record) => <div>{record?.field_type?.replaceAll('_', ' ')?.toProperCase()}</div>,
  },
  {
    title: 'Available Entities',
    width: '50%',
    render: (record) => (
      <div>
        {
          record?.applicable_entities?.map((item) => {
            let entityName = '';
            if (item?.entity_name === 'MANUFACTURING_ORDER_LINE') {
              entityName = 'MANUFACTURING_ORDER_RAW_MATERIAL';
            } else if (item?.entity_name === 'BILL_OF_MATERIAL') {
              entityName = 'BOM_FINISHED_GOOD';
            } else if (item?.entity_name === 'BILL_OF_MATERIAL_LINE') {
              entityName = 'BOM_RAW_MATERIAL';
            } else {
              entityName = item?.entity_name;
            }
            return (
              <Tag color={item?.is_active ? 'green' : 'red'} style={tagStyle}>{entityName?.replaceAll('_', ' ')?.toProperCase()}</Tag>
            );
          })
        }
      </div>
    ),
  },
  {
    title: '',
    render: (record) => (
      <div style={{
        textAlign: 'center', display: 'flex', justifyContent: 'center', alignItems: 'center',
      }}
      >
        <div
          className="roundIconButton"
          onClick={() => onUpdate(record)}
        >
          <EditOutlined />
        </div>
      </div>
    ),
  },
];

export const getCFTypeDataHelper = (entityTypes, props) => {
  const {
    globalCfV2, cfV2Invoice, cfV2customers, cfV2CreditNote,
    cfV2PurchaseRequest, cfV2PurchaseOrders, cfV2GoodReceivingNotes, cfV2APInvoice, cfV2DebitNote, cfV2ManufacturingOrder,
    cfV2SalesOrder, cfV2VendorPayout, cfV2customerPayment, cfV2StockTransfer, cfV2BillOfMaterial, cfV2Products, cfV2DocConsumption,
    cfV2Vendors, cfV2DeliveryChallan, cfV2StockAdjustment, cfV2SalesEstimate, cfV2PackingSlip, cfV2GateDocument, cfV2Batch, cfV2ReturnSlip, cfV2AnnualMaintenanceContract, cfV2PurchaseIndent,
  } = props;
  switch (entityTypes) {
    case 'PRODUCTS':
      return cfV2Products;
    case 'VENDORS':
      return cfV2Vendors;
    case 'DELIVERY_CHALLAN':
      return cfV2DeliveryChallan;
    case 'STOCK_ADJUSTMENT':
      return cfV2StockAdjustment;
    case 'BILL_OF_MATERIAL':
      return cfV2BillOfMaterial;
    case 'STOCK_TRANSFER':
      return cfV2StockTransfer;
    case 'CUSTOMER_PAYMENT':
      return cfV2customerPayment;
    case 'VENDOR_PAYOUT':
      return cfV2VendorPayout;
    case 'SALES_ESTIMATE':
      return cfV2SalesEstimate;
    case 'SALES_ORDER':
      return cfV2SalesOrder;
    case 'PACKING_SLIP':
      return cfV2PackingSlip;
    case 'GATE_DOCUMENT':
      return cfV2GateDocument;
    case 'MANUFACTURING_ORDER':
      return cfV2ManufacturingOrder;
    case 'DEBIT_NOTE':
      return cfV2DebitNote;
    case 'GOOD_RECEIVING_NOTES':
      return cfV2GoodReceivingNotes;
    case 'ACCOUNT_PAYABLE_INVOICE':
      return cfV2APInvoice;
    case 'PURCHASE_ORDERS':
      return cfV2PurchaseOrders;
    case 'PURCHASE_REQUEST':
      return cfV2PurchaseRequest;
    case 'PURCHASE_INDENT':
      return cfV2PurchaseIndent;
    case 'CREDIT_NOTE':
      return cfV2CreditNote;
    case 'CUSTOMERS':
      return cfV2customers;
    case 'INVOICE':
      return cfV2Invoice;
    case 'BATCH':
      return cfV2Batch;
    case 'CONSUMPTION_ORDER':
      return cfV2DocConsumption;
    case 'ANNUAL_MAINTENANCE_CONTRACT':
      return cfV2AnnualMaintenanceContract;
    case 'RETURN_SLIP':
      return cfV2ReturnSlip;
    default:
      return globalCfV2;
  }
};

export const getCFTypeLoadingHelper = (entityTypes, props) => {
  const {
    getCFV2InvoiceLoading, getCFV2customersLoading, getCFV2BillOfMaterialLoading, getCFV2ProductsLoading,
    getCFV2VendorsLoading, getCFV2DeliveryChallanLoading, getCFV2StockAdjustmentLoading, getCFV2StockTransferLoading,
    getCFV2customerPaymentLoading, getCFV2VendorPayoutLoading, getCFV2SalesOrderLoading, getCFV2SalesEstimateLoading, getCFV2PackingSlipLoading, getCFV2GateDocumentLoading,
    getCFV2ManufacturingOrderLoading, getCFV2DebitNoteLoading, getCFV2GoodReceivingNotesLoading,
    getCFV2APInvoiceLoading,
    getCFV2PurchaseOrdersLoading, getCFV2PurchaseRequestLoading, getCFV2CreditNoteLoading, globalCfV2Loading, getCFV2BatchLoading, getDocCFV2ConsumptionLoading, getDocCFV2AnnualContractMaintenanceLoading, getDocCFV2ReturnSlipLoading, getDocCFV2PurchaseIndentLoading,
  } = props;
  switch (entityTypes) {
    case 'PRODUCTS':
      return getCFV2ProductsLoading;
    case 'VENDORS':
      return getCFV2VendorsLoading;
    case 'DELIVERY_CHALLAN':
      return getCFV2DeliveryChallanLoading;
    case 'STOCK_ADJUSTMENT':
      return getCFV2StockAdjustmentLoading;
    case 'BILL_OF_MATERIAL':
      return getCFV2BillOfMaterialLoading;
    case 'STOCK_TRANSFER':
      return getCFV2StockTransferLoading;
    case 'CUSTOMER_PAYMENT':
      return getCFV2customerPaymentLoading;
    case 'VENDOR_PAYOUT':
      return getCFV2VendorPayoutLoading;
    case 'SALES_ESTIMATE':
      return getCFV2SalesEstimateLoading;
    case 'SALES_ORDER':
      return getCFV2SalesOrderLoading;
    case 'PACKING_SLIP':
      return getCFV2PackingSlipLoading;
    case 'GATE_DOCUMENT':
      return getCFV2GateDocumentLoading;
    case 'MANUFACTURING_ORDER':
      return getCFV2ManufacturingOrderLoading;
    case 'DEBIT_NOTE':
      return getCFV2DebitNoteLoading;
    case 'GOOD_RECEIVING_NOTES':
      return getCFV2GoodReceivingNotesLoading;
    case 'ACCOUNT_PAYABLE_INVOICE':
      return getCFV2APInvoiceLoading;
    case 'PURCHASE_ORDERS':
      return getCFV2PurchaseOrdersLoading;
    case 'PURCHASE_REQUEST':
      return getCFV2PurchaseRequestLoading;
    case 'PURCHASE_INDENT':
      return getDocCFV2PurchaseIndentLoading;
    case 'CREDIT_NOTE':
      return getCFV2CreditNoteLoading;
    case 'CUSTOMERS':
      return getCFV2customersLoading;
    case 'INVOICE':
      return getCFV2InvoiceLoading;
    case 'BATCH':
      return getCFV2BatchLoading;
    case 'CONSUMPTION_ORDER':
      return getDocCFV2ConsumptionLoading;
    case 'ANNUAL_MAINTENANCE_CONTRACT':
      return getDocCFV2AnnualContractMaintenanceLoading;
    case 'RETURN_SLIP':
      return getDocCFV2ReturnSlipLoading;    
    default:
      return globalCfV2Loading;
  }
};
